import { Anchor, Text } from '@zillow/constellation-10';
import React from 'react';
import { ModalType } from '../../../../types/ModalType';
import useModal from '../../../../hooks/useModal';

const EXPIRED_TEXT = {
  SINGULAR: 'This file has expired.',
  PLURAL: 'These files have expired.',
};

type Props = {
  isPlural?: boolean;
};

const ExpiredAttachmentsText = ({ isPlural = false }: Props): JSX.Element => {
  const { setActiveModal } = useModal();
  const mainText = isPlural ? EXPIRED_TEXT.PLURAL : EXPIRED_TEXT.SINGULAR;

  const handleShowAttachmentModal = (): void => {
    setActiveModal(ModalType.AttachmentModal);
  };

  return (
    <Text
      data-testid="attachment-expired-text"
      color="text.subtle"
      textStyle="body-xs"
      css={{ marginBottom: 'tighter' }}
    >
      {mainText}{' '}
      <span>
        <Anchor onClick={handleShowAttachmentModal} css={{ color: 'inherit' }}>
          Details here
        </Anchor>
      </span>
    </Text>
  );
};

export default ExpiredAttachmentsText;
